import { gql, useQuery } from '@apollo/client';

export const GET_EMAIL_TEMPLATE_BY_ID = gql`
  query getEmailTemplateById($emailTemplateId: String!) {
    getEmailTemplateById(emailTemplateId: $emailTemplateId) {
      _id
      subject
      body
      createdBy
    }
  }
`;

export const useGetEmailTemplateById = (emailTemplateId: string) => {
  const { data, loading } = useQuery(GET_EMAIL_TEMPLATE_BY_ID, {
    variables: { emailTemplateId },
    skip: !emailTemplateId,
  });

  const emailTemplate = data?.getEmailTemplateById || {};

  return {
    emailTemplate,
    loading,
  };
};
